import inventory from './inventory';
import order from './order';
import profile from './profile';
import payment from './paymant';
import cart from './cart';
import cmsProfile from './cms-profile';
import verificationDocument from './verification-document';
import messages from './messages'
import inventoryTranslation from './inventory-translation';
import quotationRequest from './quotation-request';
import quotation from './quotation';

export default {
  inventory,
  order,
  profile,
  payment,
  cart,
  cmsProfile,
  verificationDocument,
  messages,
  inventoryTranslation,
  quotationRequest,
  quotation,
}
